import usFlag from "../assets/images/Logo.png"
import spain from "../assets/images/Logo.png"
import germany from "../assets/images/Logo.png"
import italy from "../assets/images/Logo.png"
import russia from "../assets/images/Logo.png"

const languages = {
  sp: {
    label: "Spanish",
    flag: spain,
  },
  gr: {
    label: "German",
    flag: germany,
  },
  it: {
    label: "Italian",
    flag: italy,
  },
  rs: {
    label: "Russian",
    flag: russia,
  },
  en: {
    label: "English",
    flag: usFlag,
  },
}

export default languages
